module.exports = __webpack_public_path__ + "img/744.8919f71d.jpg";